// Use environment variable for API URL, fallback to production
export const BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.spotto.pl';
export const API_BASE_URL = `${BASE_URL}/api`;
